module.exports = __webpack_public_path__ + "static/media/story-page.dcdca6d4.png";